/** Follow browser bars/keyboard without resizing the app during pinch zoom. */
export function installVisibleViewport() {
  const viewport = window.visualViewport;
  const style = document.documentElement.style;
  const update = () => {
    const unzoomed = viewport && Math.abs(viewport.scale - 1) < .01;
    const bottom = unzoomed ? viewport.height + viewport.offsetTop : window.innerHeight;
    style.setProperty('--app-viewport-height', `${bottom}px`);
    style.setProperty('--app-viewport-bottom-gap', `${Math.max(0, window.innerHeight - bottom)}px`);
  };
  update();
  window.addEventListener('resize', update);
  viewport?.addEventListener('resize', update);
  viewport?.addEventListener('scroll', update);
  return () => {
    window.removeEventListener('resize', update);
    viewport?.removeEventListener('resize', update);
    viewport?.removeEventListener('scroll', update);
    style.removeProperty('--app-viewport-height');
    style.removeProperty('--app-viewport-bottom-gap');
  };
}
